@if (loaderIcon | async) {
<app-loader></app-loader>
}
<div class="border p-3 rounded shadow-sm">
  <div class="row g-2 align-items-center">
    <div class="col-lg-5">
      <div class="row">
        <div class="col-6">
          <p class="mb-1"><strong>{{'Vendor ID : ' | wordReplace}}</strong>{{vendorInfo?.MarketVendorId}}</p>
          <p class="mb-1"><strong>Name : </strong>{{vendorInfo?.VendorName}}</p>
        </div>
        <div class="col-6">
          <p class="mb-1"><strong>Phone : </strong> {{vendorInfo?.Telephone | phoneFormat}}</p>
          <p class="mb-1"><strong>Email : </strong> {{vendorInfo?.Email}}</p>
        </div>
      </div>
    </div>
    <div class="col-lg-7 d-flex flex-column gap-2">
      <div class="d-flex gap-2 align-items-center">
        <div>
          <label class="form-label mb-0"><strong>From</strong></label>
          <ejs-datepicker [(ngModel)]="fromDate" (ngModelChange)="onFromDateChange()" [max]="maxExpiryDate"
            [disabled]="listLatest" class="form-control p-0"></ejs-datepicker>
        </div>
        <div>
          <label class="form-label mb-0"><strong>To</strong></label>
          <ejs-datepicker [(ngModel)]="toDate" (ngModelChange)="onToDateChange()" [min]="fromDate" [max]="maxExpiryDate"
            [disabled]="listLatest" class="form-control p-0"></ejs-datepicker>
        </div>
        <div class="form-check ms-3 mt-3">
          <input class="form-check-input" type="checkbox" id="receiptPayments" [(ngModel)]="onlyWithPayment"
            (change)="onFilterChange()">
          <label class="form-check-label" for="receiptPayments">Receipts with Payments</label>
        </div>
      </div>

      <div class="d-flex align-items-center mt-2">
        <div class="form-check me-2">
          <input class="form-check-input" type="checkbox" id="listLatest" [(ngModel)]="listLatest"
            (change)="onListLatestToggle()">
          <label class="form-check-label" for="listLatest">List Latest</label>
        </div>
        <input type="number" class="form-control form-control-sm" [(ngModel)]="latestCount" [disabled]="!listLatest"
          (input)="allowOnlyDigitsForLatest($event, 5)" style="width: 18%;">
        <label class="ms-2 mb-0">Transactions</label>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12 text-start mt-2">
    <ejs-grid #gridHistory [dataSource]="gridData" [allowFiltering]="true" [height]="300" (created)="created($event)">
      <e-columns>
        <e-column field="MarketAccountReceiptId" headerText="Receipt ID" width="140"></e-column>
        <e-column field="BillDate" headerText="Bill Date" width="140" type="date" format="MM/dd/yyyy"></e-column>
        <e-column field="RentalType" headerText="Rental Type" width="140"></e-column>
        <e-column field="BookingType" headerText="Booking Type" width="150"></e-column>
        <e-column field="RentalCharge" headerText="Rental Charges" width="150" textAlign="Right" type="number"
          format="$#,##0.00;($#,##0.00)"></e-column>
        <e-column field="OtherCharge" headerText="Other Charges" width="160" textAlign="Right" type="number"
          format="$#,##0.00;($#,##0.00)"></e-column>
        <e-column field="TotalDue" headerText="Total Due" width="160" textAlign="Right" type="number"
          format="$#,##0.00;($#,##0.00)"></e-column>
        <e-column field="Paid" headerText="Amt Paid" width="160" textAlign="Right" type="number"
          format="$#,##0.00;($#,##0.00)"></e-column>
        <e-column field="print" headerText="Print" width="90" textAlign="Center">
          <ng-template #template let-data>
            <a (click)="checkPrinterSettingsOnPrint(data)"><img src="./assets/images/print.svg" class="img-fluid" /></a>
          </ng-template>
        </e-column>
        <e-column field="email" headerText="Email" width="90" textAlign="Center">
          <ng-template #template let-data>
            <a (click)="onEmail(data)"><img src="./assets/images/email.svg" class="img-fluid" /></a>
          </ng-template>
        </e-column>
        <e-column field="view" headerText="View" width="90" textAlign="Center">
          <ng-template #template let-data>
            <a (click)="onView(data)"><img src="./assets/images/view.svg" class="img-fluid" /></a>
          </ng-template>
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>
<!-- PDF Preview Modal -->
<div class="modal fade" id="viewReceiptModal" tabindex="-1" aria-labelledby="viewReceiptModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl modal-fullSize">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="viewReceiptModalLabel">Preview</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <iframe *ngIf="pdfUrl" [src]="pdfUrl" width="100%" height="500px" frameborder="0"></iframe>
      </div>
      <div class="modal-footer">
        <button class="btn btn-orange" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>